import { Component, Input } from '@angular/core';

@Component({
  selector: 'rush-icon',
  template: `
    <img
      class="clickable-icon"
      src="/assets/rabbit.png"
      height="20"
      alt="Rushed"
      certTooltip="Requested by {{ rushRequestedBy ?? 'Unknown' }}"
    />
  `,
  styles: `
    .badge {
      font-size: 1rem;
    }
  `,
  standalone: false,
})
export class RushIconComponent {
  @Input() rushRequestedBy: string | undefined;
}
